// extracted by mini-css-extract-plugin
export default {"formContainer":"user-group-editor_formContainer__2CLem"};